// extracted by mini-css-extract-plugin
module.exports =  {"headerColumn":"feedteststyle-module_headerColumn__Z71VCcEh94E3Li1AGXDq","rowColumn":"feedteststyle-module_rowColumn__jCEH1Pd5z5j5_XMLB8DH"};